import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=41c56ffb&"
import script from "./HelpMenu.vue?vue&type=script&lang=ts&"
export * from "./HelpMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports